import React, { useState } from "react";

function Productsspecification({ productDetails }) {
  const term = productDetails.term;
  const [activeTab, setActiveTab] = useState(0);

  return (
    <section className="product_details_specification pt-40 pb-40">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-10">
            <div className="tab_heading">
              <button
                className={`heading ${activeTab === 0 ? "active" : ""}`}
                onClick={() => setActiveTab(0)}
              >
                Description
              </button>

              {term !== undefined && term && term.length > 0
                ? term.map((tab, index) => (
                    <button
                      key={index}
                      className={`heading ${
                        activeTab === index + 1 ? "active" : ""
                      }`}
                      onClick={() => setActiveTab(index + 1)}
                    >
                      {tab.attribute_name}
                    </button>
                  ))
                : null}
            </div>

            <div className="tab_contents">
              {activeTab === 0 && (
                <div>
                  {typeof productDetails.description === "string" ? (
                    <p
                      dangerouslySetInnerHTML={{
                        __html: productDetails.description,
                      }}
                    />
                  ) : (
                    <p>{productDetails.description}</p> // Handle non-string description gracefully
                  )}
                </div>
              )}
              {Array.isArray(term) && term.length > 0
                ? term.map((item, index) => (
                    <div key={index}>
                      {activeTab === index + 1 && (
                        <p
                          dangerouslySetInnerHTML={{
                            __html: item.term,
                          }}
                        />
                      )}
                    </div>
                  ))
                : null}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Productsspecification;
